import React from 'react';
import {get, post, del} from '../../utils/request';
import {Col, Modal, Row, Spinner} from 'react-bootstrap';
import Alert from "../../component/Alert/Alert";
import Button from "../../component/Button/Button";
import Container from "../../component/Container/Container";
import Layout from "../../component/Layout/Layout";
import Link from "../../component/Link/Link";
import RoleNav from "../../component/RoleNav/RoleNav";
import DeleteKey from "./DeleteKey";
import {faArrowCircleLeft, faKey, faBan, faCheckCircle, faCopy, faCheck} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "../../component/Table/Table.scss"
import './access.scss';

class RoleS3Keys extends React.Component {
    constructor(props) {
        super(props);
        const roleId = props.match.params.roleId;

        this.state = {
            roleId: roleId,
            roleName: '',
            s3Keys: [],
            newKeyData: null,
            copiedField: null,
            errorMessage: "",
            successMessage: "",
            loading: true,
            loadingSuccess: false
        };

        this.loadData = this.loadData.bind(this);
        this.createS3Key = this.createS3Key.bind(this);
        this.activateS3Key = this.activateS3Key.bind(this);
        this.deactivateS3Key = this.deactivateS3Key.bind(this);
        this.deleteS3Key = this.deleteS3Key.bind(this);
        this.clearNewKeyData = this.clearNewKeyData.bind(this);
    }

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        const [roleRes, roleErr] = await get(this, "/auth/role/" + this.state.roleId);
        if (roleErr) {
            this.setState({errorMessage: "error loading role: " + roleErr, loading: false});
            return;
        }
        this.setState({roleName: roleRes.data.Name});

        const [keysRes, keysErr] = await get(this, "/auth/role/" + this.state.roleId + "/s3Key");
        if (keysErr) {
            this.setState({errorMessage: "error loading S3 keys: " + keysErr, loading: false});
            return;
        }
        this.setState({s3Keys: keysRes.data.S3Keys || [], loading: false, loadingSuccess: true});
    }

    async createS3Key() {
        this.setState({errorMessage: '', successMessage: '', newKeyData: null});

        const [res, err] = await post(this, "/auth/role/" + this.state.roleId + "/s3Key", {});
        if (err) {
            if (err.response && err.response.status === 409) {
                this.setState({errorMessage: "Maximum 2 S3 keys allowed per role"});
            } else if (err.response && err.response.data && err.response.data.Message === "role already has maximum number of s3 keys") {
                this.setState({errorMessage: "Maximum 2 S3 keys allowed per role"});
            } else {
                this.setState({errorMessage: "Error creating S3 key"});
            }
            return;
        }

        this.setState({newKeyData: res.data});

        const [keysRes, keysErr] = await get(this, "/auth/role/" + this.state.roleId + "/s3Key");
        if (!keysErr) {
            this.setState({s3Keys: keysRes.data.S3Keys || []});
        }
    }

    clearNewKeyData() {
        // Overwrite sensitive data before clearing to reduce memory exposure
        if (this.state.newKeyData) {
            const clearedData = {
                AccessKeyId: '',
                SecretAccessKey: ''
            };
            this.setState({newKeyData: clearedData}, () => {
                this.setState({newKeyData: null});
            });
        } else {
            this.setState({newKeyData: null});
        }
    }

    copyToClipboard(text, fieldName) {
        const doCopy = () => {
            this.setState({copiedField: fieldName});
            setTimeout(() => {
                this.setState({copiedField: null});
            }, 2000);
        };

        navigator.clipboard.writeText(text).then(() => {
            doCopy();
        }).catch(() => {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            doCopy();
        });
    }

    async activateS3Key(accessKeyId) {
        const [_, err] = await post(this, "/auth/role/" + this.state.roleId + "/s3Key/" + accessKeyId + "/activate", {});
        if (err) {
            this.setState({errorMessage: "error activating S3 key: " + err});
            return;
        }
        const [keysRes, keysErr] = await get(this, "/auth/role/" + this.state.roleId + "/s3Key");
        if (!keysErr) {
            this.setState({s3Keys: keysRes.data.S3Keys || []});
        }
    }

    async deactivateS3Key(accessKeyId) {
        const [_, err] = await post(this, "/auth/role/" + this.state.roleId + "/s3Key/" + accessKeyId + "/deactivate", {});
        if (err) {
            this.setState({errorMessage: "error deactivating S3 key: " + err});
            return;
        }
        const [keysRes, keysErr] = await get(this, "/auth/role/" + this.state.roleId + "/s3Key");
        if (!keysErr) {
            this.setState({s3Keys: keysRes.data.S3Keys || []});
        }
    }

    async deleteS3Key(accessKeyId) {
        const [_, err] = await del(this, "/auth/role/" + this.state.roleId + "/s3Key/" + accessKeyId);
        if (err) {
            this.setState({errorMessage: "error deleting S3 key: " + err});
            return;
        }
        const [keysRes, keysErr] = await get(this, "/auth/role/" + this.state.roleId + "/s3Key");
        if (!keysErr) {
            this.setState({s3Keys: keysRes.data.S3Keys || []});
        }
    }

    render() {
        const { roleId, roleName, s3Keys, newKeyData, copiedField, loading, loadingSuccess, errorMessage, successMessage } = this.state;
        const keyRows = s3Keys.map((key, index) => (
            <tr key={key.AccessKeyId}>
                <td data-label="#">{index + 1}</td>
                <td data-label="Key">{key.AccessKeyId}</td>
                <td data-label="Status">{key.Status}</td>
                <td>
                    {key.Status === "inactive" &&
                        <Button
                            className="success-outline btn btn-md"
                            faIcon={faCheckCircle}
                            label="Activate"
                            onClick={() => this.activateS3Key(key.AccessKeyId)}
                        />
                    }
                    {key.Status === "active" &&
                        <Button
                            className="primary-outline btn btn-md"
                            faIcon={faBan}
                            label="Deactivate"
                            onClick={() => this.deactivateS3Key(key.AccessKeyId)}
                        />
                    }
                </td>
                <td>
                    <DeleteKey delete={this.deleteS3Key} s3Key={key.AccessKeyId}/>
                </td>
            </tr>
        ));

        return (
            <Layout activeMenu="/access" isLoggedIn={true}>
                <h1>Role <span className="entity-name">{roleName}</span></h1>

                {loading && (
                    <>
                        <Spinner animation="border" variant="primary"/> Loading...
                        <br/><br/>
                    </>
                )}

                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                {successMessage && <Alert variant="success">{successMessage}</Alert>}

                {loadingSuccess && (
                    <>
                        <RoleNav roleId={roleId}/>
                        <Container>
                            <Modal show={!!newKeyData} backdrop="static" keyboard={false} size="lg">
                                <Modal.Header>
                                    <Modal.Title>New key created!</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Alert variant="warning">
                                        <strong>Please copy the secret access key to a safe place. It will be shown only once!</strong>
                                    </Alert>
                                    <Row className="mb-2">
                                        <Col sm="4"><strong>Access Key Id</strong></Col>
                                        <Col sm="7"><code>{newKeyData?.AccessKeyId}</code></Col>
                                        <Col sm="1">
                                            <span
                                                style={{cursor: 'pointer', color: copiedField === 'accessKeyId' ? 'green' : 'inherit'}}
                                                onClick={() => this.copyToClipboard(newKeyData?.AccessKeyId, 'accessKeyId')}
                                                title={copiedField === 'accessKeyId' ? 'Copied!' : 'Copy to clipboard'}
                                            >
                                                <FontAwesomeIcon icon={copiedField === 'accessKeyId' ? faCheck : faCopy}/>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="4"><strong>Secret Access Key</strong></Col>
                                        <Col sm="7"><code>{newKeyData?.SecretAccessKey}</code></Col>
                                        <Col sm="1">
                                            <span
                                                style={{cursor: 'pointer', color: copiedField === 'secretAccessKey' ? 'green' : 'inherit'}}
                                                onClick={() => this.copyToClipboard(newKeyData?.SecretAccessKey, 'secretAccessKey')}
                                                title={copiedField === 'secretAccessKey' ? 'Copied!' : 'Copy to clipboard'}
                                            >
                                                <FontAwesomeIcon icon={copiedField === 'secretAccessKey' ? faCheck : faCopy}/>
                                            </span>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        className="primary btn"
                                        faIcon={faCheckCircle}
                                        label="Ok, I have copied the keys"
                                        onClick={this.clearNewKeyData}
                                    />
                                </Modal.Footer>
                            </Modal>

                            {s3Keys.length < 2 && !newKeyData && (
                                <div className="d-flex justify-content-end mb-3">
                                    <Button
                                        className="primary btn"
                                        faIcon={faKey}
                                        label="Create new key"
                                        onClick={this.createS3Key}
                                    />
                                </div>
                            )}

                            {keyRows.length > 0 && (
                                <table className="table-ctr">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Key</th>
                                            <th>Status</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>{keyRows}</tbody>
                                </table>
                            )}

                            {keyRows.length === 0 && !newKeyData && (
                                <p>No S3 keys created yet for this role.</p>
                            )}

                            {s3Keys.length >= 2 && (
                                <p>Maximum 2 keys allowed per role.</p>
                            )}
                        </Container>
                        <div className="d-flex justify-content-end mt-3">
                            <Link
                                className="primary-outline btn btn-md mr3"
                                faIcon={faArrowCircleLeft}
                                href="/access"
                                label="Back to list"
                            />
                        </div>
                        <br/>
                        <Alert variant="info">
                            <b>For technical configurations, please consult our documentation</b> <br/>
                            <a href={`${process.env.REACT_APP_HOMEPAGE_URL}/resources/s3-api-permissions-and-compatibility`} target="_blank" rel="noopener">S3 API permissions and compatibility</a>
                        </Alert>
                    </>
                )}
            </Layout>
        );
    }
}

export default RoleS3Keys
